export const EXCMDEVICE_CREATE_RESET = 'EXCMDEVICE_CREATE_RESET'
export const EXCMDEVICE_CREATE_SET_CREATED = 'EXCMDEVICE_CREATE_SET_CREATED'
export const EXCMDEVICE_CREATE_SET_ERROR = 'EXCMDEVICE_CREATE_SET_ERROR'
export const EXCMDEVICE_CREATE_SET_VIOLATIONS = 'EXCMDEVICE_CREATE_SET_VIOLATIONS'
export const EXCMDEVICE_CREATE_TOGGLE_LOADING = 'EXCMDEVICE_CREATE_TOGGLE_LOADING'
